import { Lesson, LessonEnrolment } from '../../services/classes/types';
import { Course } from '../../services/courses/types';

import { getNameFromCourse, getShortNameFromCourse } from './courses';
import { joinNames } from './formatText';

export const getClassSubject = (classId: string) => classId.split('#')[0];
export const getClassId = (classId: string) => classId.split('#')[1];
export const getClassName = (classId: string, course: string) => `cl-${course}-${classId}`;

export const getLessonSubject = (lesson: Lesson) => lesson.subjectClassIdentifier.split('#')[0];
export const getLessonClass = (lesson: Lesson) => lesson.subjectClassIdentifier.split('#')[1];
export const getLessonCourse = (lesson: Lesson) => lesson.lesson.split('#')[0];
export const getLessonCode = (lesson: Lesson) => lesson.lesson.split('#')[1];
export const getLessonCourseAndCode = (lesson: Lesson) => lesson.lesson.split('#').slice(0, -1).join('#');
export const getClassLessonIdentifier = (lesson: Lesson) => `${lesson.subjectClassIdentifier}#${lesson.lesson}`;
export const getLessonClassName = (lesson: Lesson) =>
  getClassName(getLessonClass(lesson), getLessonCourse(lesson));
export const getLessonLabel = (lesson: Lesson, courses: Course[]) =>
  joinNames([getNameFromCourse(getLessonCourse(lesson), courses), getLessonCode(lesson)]);

export const getLessonEnrolmentSubject = (lessonEnrolment: LessonEnrolment) =>
  lessonEnrolment.classLessonIdentifier.split('#')[0];
export const getLessonEnrolmentClass = (lessonEnrolment: LessonEnrolment) =>
  lessonEnrolment.classLessonIdentifier.split('#')[1];
export const getLessonEnrolmentCourse = (lessonEnrolment: LessonEnrolment) =>
  lessonEnrolment.classLessonIdentifier.split('#')[2];
export const getLessonEnrolmentLessonCode = (lessonEnrolment: LessonEnrolment) =>
  lessonEnrolment.classLessonIdentifier.split('#')[3];
export const getLessonEnrolmentClassName = (lessonEnrolment: LessonEnrolment) =>
  getClassName(getLessonEnrolmentClass(lessonEnrolment), getLessonEnrolmentCourse(lessonEnrolment));
export const getLessonEnrolmentLabel = (lessonEnrolment: LessonEnrolment, courses: Course[]) =>
  joinNames([
    getNameFromCourse(getLessonEnrolmentCourse(lessonEnrolment), courses),
    getLessonEnrolmentLessonCode(lessonEnrolment),
  ]);
export const getLessonEnrolmentShortLabel = (lessonEnrolment: LessonEnrolment, courses: Course[]) =>
  joinNames([
    getShortNameFromCourse(getLessonEnrolmentCourse(lessonEnrolment), courses),
    getLessonEnrolmentLessonCode(lessonEnrolment),
  ]);
export const getLessonEnrolmentLessonId = (lessonEnrolment: LessonEnrolment) =>
  lessonEnrolment.classLessonIdentifier.split('#').slice(2).join('#');
